import { faArrowLeft, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, FormControlLabel, IconButton, MobileStepper, Radio, RadioGroup, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { QuestionarioToPasswordOptions } from '../../../interfaces/entities/QuestionarioToPasswordOptions';
import { sxButtonOptionRecovery, sxTypographyTitleLeft, sxValidationMessage } from '../sxProps';

export interface ConfirmationDataRecoveryProps {
  formBack: () => void;
  questions: QuestionProps[];
  validateQuestiosToRecovery: (answers: Array<QuestionarioToPasswordOptions>) => void;
}

export interface OptionQuestionProps {
  valor: string;
  descr: string
}

export interface QuestionProps {
  questao: string;
  codQuestao: string;
  opcoes: OptionQuestionProps[];
}


const QuestionsToRecoveryPassword: React.FC<ConfirmationDataRecoveryProps> = ({ formBack, questions, validateQuestiosToRecovery }) => {

  const [activeStep, setActiveStep] = useState(0);
  const [showError, setShowError] = useState<boolean>(false);
  const [listAnswersOptions, setListAnswersOptions] = useState<Array<QuestionarioToPasswordOptions>>([]);

  const radioGroupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (radioGroupRef.current) {
      radioGroupRef.current.focus();
    }
  }, [activeStep])

  const nextQuestion = () => {
    const isAnswerMissing = !listAnswersOptions[activeStep]?.resposta;

    if (isAnswerMissing) {
      setShowError(true);
      return;
    };

    if (activeStep !== (questions.length - 1)) {
      setShowError(false);
      setActiveStep(activeStep + 1);
      return;
    };

    validateQuestiosToRecovery(listAnswersOptions);

  };

  const handleAnswersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedOption = e.target.value;
    const selectedOptionValor = questions[activeStep]?.opcoes?.find(item => item.descr === selectedOption)?.valor || "";

    var optionAnswer: QuestionarioToPasswordOptions = {
      resposta: selectedOptionValor,
      codQuestao: questions[activeStep]?.codQuestao
    };

    var answers = listAnswersOptions;
    answers.push(optionAnswer);

    setListAnswersOptions(answers);
  }


  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div style={textStyleAccessibility} className='container-login-painel-rigth'>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton aria-label="Voltar" onClick={() => formBack()} type="button">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography component="h1" style={textStyleAccessibility} sx={sxTypographyTitleLeft} className='margin-bottom-painel-rigth'>Questionário</Typography>
        </div>
      </div>
      <div className='container-text-recovery '>
        <div className='width-100'  aria-label={questions[activeStep].questao}>
          <Typography sx={{ textAlign: 'start', color: '#4C4C4C' }}>{questions[activeStep].questao}</Typography>
        </div>
        <div className='width-100'>
          <RadioGroup 
            onChange={handleAnswersChange} 
            aria-label={questions[activeStep].questao}
          >
            {questions[activeStep].opcoes?.map((item, index) =>
              <FormControlLabel key={index} value={item.descr}
                ref={index === 0 ? radioGroupRef : null}
                control={<Radio style={{ background: 'white' }} color='default' />}
                label={
                  <div>
                    <Typography style={{ color: '#4C4C4C', ...textStyleAccessibility}}>{item.descr}</Typography>
                  </div>
                } />
            )}
          </RadioGroup>
        </div>
        <MobileStepper
          variant="dots"
          steps={questions.length}
          position="static"
          activeStep={activeStep}
          sx={{ maxWidth: 400, flexGrow: 1 }}
          nextButton={<></>}
          backButton={<></>}
        />
      </div>
      {showError && (
        <div className="container-validation-message">
          <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
          <Typography sx={sxValidationMessage} style={textStyleAccessibility}>
            {'Por favor, selecione uma opção antes de continuar.'}
          </Typography>
        </div>
      )}
      <Button style={buttonStyleAccessibility} sx={sxButtonOptionRecovery} onClick={() => nextQuestion()} variant='contained'>
        <Typography style={buttonTextStyleAccessibility}>CONTINUAR</Typography>
      </Button>
    </div>
  )
}

export default QuestionsToRecoveryPassword